import { annotationColorValues } from "@/view/AnnotatedText/AnnotatedText.constants";

export const colorPickerColors = [
  { penName: annotationColorValues.yellow, label: "yellow" },
  { penName: annotationColorValues.blue, label: "blue" },
  { penName: annotationColorValues.green, label: "green" },
  { penName: annotationColorValues.pink, label: "pink" },
];
